import formsJson from '@/../functions/shared/forms.json'
import patientFormsJson from '@/../functions/shared/formPatient.json'
import formEvents from './formEvents'
import formCustomFormulas from './formCustomFormulas'
import formCharts from './formCharts'
import { diff } from 'deep-object-diff'
import _ from 'lodash'
import axios from 'axios'

// const API_URL = 'https://app.ultrahealth.care/functions/calcs'
// const API_URL = 'https://dev.ultrahealth.care/functions/calcs'
// const API_URL = 'http://localhost:5000/ultracarebr/southamerica-east1/calcs'
const API_URL = 'https://southamerica-east1-ultracarebr.cloudfunctions.net/calcs'

let CACHE = null
const isWeb = typeof localStorage !== 'undefined'

function getFormCalcs (forms) {
  let formulas = {}
  for (let i = 0; i < forms.components.length; i++) {
    getFieldCalcs(forms.components[i], forms.components[i].key, formulas)
  }
  return formulas
}

// retorna todos os campos que contenham formulas, eventos e parametros
function getFieldCalcs (component, key, formulas) {
  let lastKey = key
  let currentFormula = formulas || { }
  if (component.components && component.components.length > 0) {
    component.components.forEach((item) => {
      if (!lastKey || item.type === 'form') lastKey = ''
      let currentKey = lastKey === '' ? item.key : lastKey + '.' + item.key
      getFieldCalcs(item, currentKey, currentFormula)
    })
  } else {
    if (!currentFormula.fields) currentFormula.fields = {}
    currentFormula.fields[key] = component
    if (component.formulas) {
      currentFormula[lastKey] = { formulas: component.formulas }
    }
    if (component.events) {
      if (!currentFormula[lastKey]) currentFormula[lastKey] = {}
      currentFormula[lastKey]['events'] = component.events
    }
    if (component.param) {
      if (!currentFormula.params) currentFormula.params = {}
      if (!currentFormula.params[component.param]) currentFormula.params[component.param] = []
      currentFormula.params[component.param].push(key)
    }
    if (component.paramRef) {
      if (!currentFormula.paramRefs) currentFormula.paramRefs = {}
      if (!currentFormula.paramRefs[component.paramRef]) currentFormula.paramRefs[component.paramRef] = []
      currentFormula.paramRefs[component.paramRef].push(key)
    }
  }
  return currentFormula
}

// retorna todos os acionadores (param) das formulas e eventos
function getFormulaTriggers (fieldCalcs) {
  const triggers = {}

  for (let key in fieldCalcs) {
    let fieldCalc = fieldCalcs[key]
    let formulas = fieldCalc.formulas
    if (formulas) {
      for (let authorKey in formulas.authors) {
        let authorFormula = formulas.authors[authorKey]
        for (let param in authorFormula.params) {
          let fieldTrigger = authorFormula.params[param]
          let trigger = triggers[fieldTrigger] || {}
          if (!trigger.targetKeys) trigger.targetKeys = {}
          if (!trigger.targetKeys[key]) trigger.targetKeys[key] = []
          trigger.targetKeys[key].push(authorKey) // event
          triggers[fieldTrigger] = trigger
        }
      }
    }
    if (fieldCalc.events) {
      if (!triggers[key]) triggers[key] = {}
      triggers[key].events = fieldCalc.events
    }
  }
  return triggers
}

async function axiosCached (params, formula) {
  let data = null
  const cacheKey = 'ultracare-calcs-cache'
  if (!CACHE) {
    CACHE = (isWeb ? JSON.parse(localStorage.getItem(cacheKey)) : {}) || {}
  }
  const paramsKey = JSON.stringify(params)
  if (CACHE[formula.apiPath] && CACHE[formula.apiPath][paramsKey]) {
    data = CACHE[formula.apiPath][paramsKey]
  } else {
    // let response = await axios.post(`${API_URL}${formula.apiPath}`, params)
    let response = await axios.post(API_URL, { path: formula.apiPath, params })
    data = response.data
    if (!CACHE[formula.apiPath]) CACHE[formula.apiPath] = {}
    CACHE[formula.apiPath][paramsKey] = data
    if (isWeb) localStorage.setItem(cacheKey, JSON.stringify(CACHE))
  }
  return data
}

// Executa a formula dos campos
async function execFormula (triggerKey, targetKey, authors, data, itemIndex) {
  // console.debug('execFormula', triggerKey, targetKey, authors, itemIndex)

  let forms = data.forms
  if (!forms) return {}
  let result = {}

  let formulas = fieldCalcs[targetKey].formulas
  let value = forms[targetKey.replace(/(\.\w+)(\$)/, '$1_' + itemIndex)]
  let author
  if (value && typeof value === 'object') author = value.author
  if (!author) author = formulas.default
  // Caso o parametro não consta no autor, return.
  if (!authors.includes(author)) return

  // FORMULA
  const formula = formulas.authors[author]
  let targetKeyFixed = targetKey.replace(/(\.\w+)(\$)/, '$1_' + itemIndex)

  // PARAMS
  const params = {}
  for (let param in formula.params) {
    let paramKey = formula.params[param]
    const key = paramKey.replace(/(\.\w+)(\$)/, '$1_' + itemIndex)
    let paramValue = forms[key]

    if ([undefined, '', null, NaN].indexOf(paramValue) > -1) {
      // Campo opcional
      if ((formula.optional && formula.optional.includes(param))) continue
      let result = {forms: {}}
      result.forms[targetKeyFixed] = null
      return result
    } else {
      params[param] = paramValue
    }
  }

  if (formula.custom) {
    // CUSTOM
    result = await formCustomFormulas[author](targetKeyFixed, params, data)
  } else {
    // API CALCS
    try {
      result.forms = {}

      // CACHE - verifica se a consulta está na cache
      // TODO: Ativar o cache do AXIOS
      let data = await axiosCached(params, formula)
      // CACHE END

      result.forms[targetKeyFixed] = { author: author, ...data }
      // console.debug('API', params, result.forms[targetKeyFixed])
    } catch (e) {
      result.forms[targetKeyFixed] = { author: author, result: 'error', error: e.toString(), percentil: undefined }
    }
  }

  // console.debug('execFormula result', result)
  return result
}

function getItemIndexes (itemIndex, targetKey, forms) {
  let arrItemIndex
  if (itemIndex) {
    arrItemIndex = [itemIndex]
  } else {
    if (targetKey.match(/\$/)) {
      // procura item keys no form
      // let targetRegex = targetKey.replace(/\$/, '_(\\d)')
      // let keys = Object.keys(forms).filter(k => k.match(targetRegex))
      // arrItemIndex = keys.map(k => k.match(targetRegex)[1])

      let qtd = 0
      if (targetKey.match(/feto\$/)) {
        let qtdFetos = forms['gestationalAge.info.fetos']
        if (qtdFetos) {
          qtd = parseInt(qtdFetos)
        }
      } else if (targetKey.match(/saco\$/)) {
        let qtdSacos = forms['gestationalAge.info.qtdSacoGestacional']
        if (qtdSacos) {
          qtd = parseInt(qtdSacos)
        }
      }
      if (!qtd) return []
      arrItemIndex = [...Array(qtd + 1).keys()].slice(1)
    } else {
      arrItemIndex = [null]
    }
  }
  return arrItemIndex
}

function applyParams (forms, params, config) {
  // Seta o valor nos fields
  function setFieldsValue (paramData, paramFields) {
    // console.log('setFieldsValue', paramData, paramFields)
    if (!paramFields) return
    let paramValue = paramData.unit === 'cm' ? paramData.value * 10 : paramData.value
    paramValue = Math.round(paramValue * 100) / 100
    for (let j = 0; j < paramFields.length; j++) {
      let targetKey = paramFields[j]
      // console.log('targetKey', targetKey)
      let formKey = targetKey.match(/(\w+)\./)[1]
      let formHasData = forms[`${formKey}.hasData`]
      // console.log('formHasData', formHasData)
      if (!formHasData) continue
      let key = targetKey.replace('$', `_${paramData.fetus}`)
      if (!forms[key] || forms[key] === '')forms[key] = paramValue
    }
  }

  // retorna os campos que se enquadram na config
  function getMatchFields (dicomParam, deviceId) {
    // Verifica se o param se enquadra na config
    function matchConfig (config) {
      if (!config) return false
      let items = Array.isArray(config) ? config : [config]
      if (items.length === 0) return false
      for (let item of items) {
        let match = true
        for (let attr in item) {
          // verifica se a config e param estão em branco ou se são iguais
          if (attr === 'unit') continue
          if ((!item[attr] && !dicomParam[attr]) || item[attr] === dicomParam[attr]) continue
          match = false
          break
        }
        if (match) return true
      }
      return false
    }

    const fields = []

    let configDevice = config[deviceId]

    // Percorre cada param config
    for (let field in configDevice) {
      let config = configDevice[field]
      if (!matchConfig(config)) continue
      // console.log('field', field)
      fields.push(field)
    }
    return fields
  }

  if (params) {
    if (!forms) forms = {}
    for (let deviceId in params) {
      let paramsList = params[deviceId]
      for (let i = 0; i < paramsList.length; i++) {
        let dicomParam = paramsList[i]
        if (!dicomParam || !dicomParam.value) continue
        const paramFields = getMatchFields(dicomParam, deviceId)
        if (_.isEmpty(paramFields)) continue
        setFieldsValue(dicomParam, paramFields)
      }
    }
  }

  return forms
}

function applyEvolutionCharts (data, changes) {
  function getAuthor (chartField) {
    let keyAuthorRef = chartField.authorRef
    if (keyAuthorRef) {
      let fieldAuthorRef = data.forms[keyAuthorRef.replace(/\$/, '_1')]
      if (fieldAuthorRef) {
        let author = fieldAuthorRef.author
        if (author) {
          return author
        }
      }
    }
    return chartField.author
  }

  function execParam (param) {
    // busca os evolution charts associados
    let chartsKeys = paramRefs[param]
    if (!chartsKeys) return

    // percorre cada evolution chart
    for (let i = 0; i < chartsKeys.length; i++) {
      let item = {}

      // Monta as keys
      let chartKey = chartsKeys[i]

      // HasData
      let formKey = chartKey.match(/(\w+)\./)[1]
      let formHasData = data.forms[`${formKey}.hasData`]
      if (!formHasData) {
        if (result.forms[chartKey]) result.forms[chartKey] = null
        continue
      }

      // Field com os metadados do chart
      let chartField = fieldsConfig[chartKey]

      // Define o autor
      item.author = getAuthor(chartField)

      // Busca os pontos
      let fields = paramsConfig[chartField.paramRef]
      if (!fields) continue
      let qtdItems = data.forms[chartField.counterRef] || 1
      item.result = formCharts.chartPoints(interactions, fields, qtdItems, chartField.xPointRef)
      result.forms[chartKey] = item
    }
  }

  const fieldsConfig = fieldCalcs.fields
  const paramsConfig = fieldCalcs.params
  const paramRefs = fieldCalcs.paramRefs

  if (!data || !changes || !changes.forms || !data.gestation) return

  let result = { forms: {} }
  let interactions = data.gestation.interactions || []
  interactions.push(data)

  // Percorre cada campo alterado
  for (let key in changes.forms) {
    let params
    if (key === 'gestationalAge.info.calculada') {
      // recalcula todos os parametros
      params = Object.keys(paramRefs)
    } else {
      // metadados do campo alterado
      let keyFixed = key.replace(/(\.\w+)_(\d)/, '$1$')
      let fieldConfig = fieldsConfig[keyFixed]
      if (!fieldConfig) continue

      let param = fieldConfig.param
      if (!param) continue
      params = [param]
    }

    for (let i = 0; i < params.length; i++) {
      let param = params[i]
      execParam(param)
    }
  }
  return result
}

async function confirmDataChanges (data, changes) {
  let dataChanged = _.merge(data, changes)
  let resultChanges = {}

  // Process changes
  if (changes.forms) {
    for (let changedKey in changes.forms) {
      // KEY
      let m = changedKey.match(/\.\w+_(\d)/)
      // indice do item
      let itemIndex
      // Key com $ no nome
      let fixedKey
      if (m) {
        itemIndex = m[1]
        fixedKey = changedKey.replace(/(\.\w+)_(\d)/, '$1$')
      } else {
        itemIndex = null
        fixedKey = changedKey
      }

      // TRIGGER
      let trigger = calcTriggers[fixedKey]
      if (trigger) {
        if (trigger.targetKeys) {
          for (let targetKey in trigger.targetKeys) {
            // Verifica se o form está adicionado
            let formKey = targetKey.match(/(\w+)\./)[1]
            let formHasData = dataChanged.forms[`${formKey}.hasData`]
            let formSomeData = Object.keys(dataChanged.forms).some(key => key.startsWith(`${formKey}`))
            if (!formHasData && !formSomeData) continue
            // console.debug('FIELD TRIGGER FORMULAS TARGET KEY', changedKey, targetKey)

            // formula para um item especifico
            let arrItemIndex = getItemIndexes(itemIndex, targetKey, dataChanged.forms)
            for (let i = 0; i < arrItemIndex.length; i++) {
              let dataFormulaChanges = await execFormula(changedKey, targetKey, trigger.targetKeys[targetKey], dataChanged, arrItemIndex[i])
              resultChanges = _.merge(resultChanges, dataFormulaChanges)
              dataChanged = _.merge(dataChanged, dataFormulaChanges)
            }
          }
        }
        if (trigger.events) {
          // console.debug('FIELD TRIGGER EVENTS', changedKey, trigger.events)
          for (let i = 0; i < trigger.events.length; i++) {
            let formFormulaChanges = formEvents[trigger.events[i]](dataChanged, changes)
            resultChanges = _.merge(resultChanges, formFormulaChanges)
            dataChanged = _.merge(dataChanged, formFormulaChanges)
          }
        }
      }
    }
  }

  if (_.isEqual(resultChanges, changes)) {
    return {}
  } else {
    return resultChanges
  }
}

// Processa o formulario com os novos dados
async function dataApplyChanges (data, changes) {
  // console.debug('ProcessForm changed fields', changes)

  let dataCloned = _.merge(_.cloneDeep(data), changes)
  let newChanges = {}
  if (Object.keys(changes).length > 0) {
    newChanges = await confirmDataChanges(dataCloned, changes)
  } else {
    return dataCloned
  }

  return dataApplyChanges(dataCloned, newChanges)
}

function fields () {
  return fieldCalcs
}

function triggers () {
  return calcTriggers
}

formsJson.components.unshift(patientFormsJson)
const fieldCalcs = getFormCalcs(formsJson)
// console.debug(fieldCalcs)

let calcTriggers = getFormulaTriggers(fieldCalcs)
// console.debug(calcTriggers)

export default {
  async exec (data, changes) {
    const processedData = await dataApplyChanges(data, changes)
    let changedFields = diff(data, processedData)
    // Build evolution charts
    let chartChanges = applyEvolutionCharts(processedData, changedFields)
    if (chartChanges) {
      changedFields = _.merge(changedFields, chartChanges)
    }
    // console.debug('END changedFields', changedFields)
    return changedFields
  },

  applyParams,

  fields,

  triggers

}



// WEBPACK FOOTER //
// ./src/api/formCalcs.js